export default {
  //Bulgarian bg(languagecode) BG(countrycode)  България / Български
 LandingPage: {
   intro_sub:
     'Подари втори живот на опаковката и дай своя принос за опазване на природата',
   title: 'Опаковка на Samsung upcycle',
   sequence1_1: 'Помогни ни да намалим отпадъците',
   sequence1_2:
     'като използваш опаковката на продукт за домашни цели. Чети нататък, за да разбереш как да го направиш.',
   sequence2_1: 'Представяме ви upcycle опаковката на Samsung',
   sequence2_2:
     'От нея могат да бъдат направени различни предмети, които да ти бъдат полезни в домакинството',
   sequence3_1: 'Следвай отпечатаните точки на опаковката',
   sequence3_2:
     'Изрежи, както е указано в инструкциите, и сглоби, за да създадеш интересен предмет',
   sequence4_1: 'Избери предмета, който би искал да сглобиш',
   sequence4_2:
     'Чети надолу и избери опаковката на своя модел продукт. След това разгледай различните варианти да я използваш за създаване на нов предмет. Твоето пътешествие в света на дизайна и творчеството започва сега.',
   selectBox: 'Избери твоя модел продукт',
   moreActivity:
     "За повече информация относно екологчните инициативи на Samsung",
   OLED: 'OLED',
   QLED8K: 'QLED', //update
   UHD: 'UHD', //update
   FHD: 'FHD',
   HD: 'HD',
   theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
   /*moreActivityLink: open at 6/8
     'https://www.samsung.com/bg/sustainability/overview/',*/
    //moreActivityLink:'https://www.samsung.com/bg/aboutsamsung/sustainability/strategy',
    moreActivityLink: 'https://www.samsung.com/bg/sustainability/overview/',
   footer: `
   Copyright © 2019-2021 SAMSUNG Всички права запазени.`,
 },
 ProductPage: {
   selectDesign: 'Избери дизайн,',
   selectDesignDezeen: 'Samsung X Dezeen', //update
   selectDesignSoccer: 'Samsung X Football', 
   tvConsole: 'ТВ конзола',
   StorageBox: 'Кутия за съхранение',
   MagazineRack: 'Стойка за списания',
   CatHouse: 'Къщичка за котки',
   CatTunnel: 'Котешки тунел',
   BookShelf: 'Лавица за книги',
   DeskShelf: 'Рафт за бюро',
   BlackRhino: 'Застрашени\n животни: \nчерен носорог', //update
   PolarBear: 'Застрашени\n животни: \nполярна мечка', //update
   SeaTurtle: 'Застрашени\n животни: \nморска костенурка', //update
   TheRider: 'The Rider', //update
   Kibe: 'Kibe', //update
   Tessellate: 'Tessellate', //update
   Twist: 'Twist', //update
   AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
   BlastOffClubHouse: 'Blast Off \n Club House', //update
   KinokoTable: 'Маса Kinoko', //update
   Magnuss: 'Magnuss', //update
   GIO: 'Gio', //update
   PostCardPlanter: 'Postcard \n Planter', //update
   SneakerRack: 'Sneaker \n Rack', //update
   TheSoban: 'The Soban', //update
   ToolBox: 'Кутия за инструменти', //update
   DeskStationary: 'Канцеларски материали',
   CoinBank: 'Касичка',
   MobileScanner:'Стойка за скенер за смартфон',
   TabletScanner:'Стойка за скенер за таблет',
   PetStairs:'Стълби за домашни любимци',
   PetFurniture: 'Pet Friendly Furniture',
   ShoeRackA:'Shoe Rack_A',
   ShoeRackB:'Shoe Rack_B',
   WineRackDog:'Wine Rack Dog',
   WineRack:'Wine Rack',
   mins: 'минути',
   all:'ALL',
   in: 'инча',
   inOnly: 'само в инчове',
   allBoxSize: 'Всички размери на кутията',
   soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
 },
 DetailGuidePage: {
   1:'1',
   2:'2',
   3:'3',
   instructions: 'Инструкции',
   prepare: 'Приготви кутията',
   LetsDesign: "Да започваме да творим",
   drawParts: 'Начертай елементите върху кутията',
   note1: 'Имай предвид, че позицията на графиката може да варира в зависимост от държавите и размерите',
   note2: 'Първо скицирай целия чертеж, така че да се събере на кутията',
   numberSpace: 'число = разстояние между точките',
   diagonal: 'Диагонал',
   LEFT: 'Лява страна',
   RIGHT: 'Дясна страна',
   TOP: 'Горна страна',
   TOP1:'Горна страна 1',
   TOP2:'Горна страна 2',
   BACK: 'Задна страна',
   MIDDLE: 'Среда',
   MIDDLE2: 'Среда 2',
   BOTTOM: 'ДОЛНА СТРАНА',
   FRONT: 'Предна страна',
   SIDE: 'Страница',
   secondSIDE: 'Втора страница',
   secondSIDE1: 'Втора страница 1',
   secondSIDE2: 'Втора страница 2',
   LEG: 'Крак', //update
   JOINT: 'Сглобка', //update
   FACE: 'Лице', //update
   DRAWERBOTTOM: 'Дъно на чекмедже', //update
   DRAWERSIDE: 'Страница на чекмедже', //update
   NOSE: 'Нос', //update
   HANDLE: 'Дръжка', //update
   BOTTOMSIDE: 'Долна страна', //update
   TOPSIDE: 'Горна страна', //update
   WING: 'Крило', //update
   cutAndAssemble: "Да изрежем и да сглобим",
   beCareful: 'Внимавай да не се нараниш, докато използваш ножа',
   cutOutParts: 'Изрежи всички елементи',
   assemble: 'Сглоби',
   Assemblyguide: 'Ръководство за монтаж', //update
   fold: 'Пример за сгъване',
   foldGuide: 'Използвай ръб на мебел, за да сгънеш правилно картона',
   foldGuideDezeen:
     'Използвай инструмент, за да оформиш сгъвка върху пунктирната линия.', //update
   glue: 'Нанеси лепило или залепи равномерно с тиксо.', //update
   cable: 'Използвай кабелни връзки или въженца за свързване', //update
   done: 'Готово!',
   goBack: 'Върни се в главното меню',
 },
 CautionPage: {
   CAUTION: 'ВНИМАНИЕ',
   needItem: 'Ще ти трябват тези инструменти',
   children: 'Децата трябва бъдат под надзора на възрастни',
   mat:
     'Моля, сложи постелка на пода, за да не го надраскаш при сглобяването.',
   doNotPutHeavyThing:
     'Не стъпвай и не сядай върху тези мебели и не поставяй тежки неща върху тях',
   doNotThrow:
     'Не хвърляй и не ритай мебелите към хора и животни.',
   stayAwayFlame: 'Дръж ги далеч от огън',
   stayAwayWater: 'Съхранявай ги далеч от вода и влага',
   mayDamaged: '* Кутията от телевизора може да бъде повредена по време на транспортирането.',
   companyDoestResponsible:
     '* Компанията не носи отговорност за повреди или наранявания по време на сглобяването на мебелите',
   cannotBeReturned:
     '* Продуктът с повредена кутия не може да бъде върнат само заради увредената опаковка',
   understand: 'Добре, разбрах',
 },
 PrivacyPolicy: {
   title: 'Политика за поверителност',
 },
 GoingGreen: {
   visual: {
     title: 'Going Green',
     text1:
       'Започнахме да използваме по-малко хартия и мастило за повечето опаковки за нашите телевизори, за да потвърдим ангажимента си към принципите на устойчивото развитие.',
     text2:'',
     text2_special:
       '(* Горното не се отнася за определени модели, включително лайфстайл телевизори)',
     text3: 'Натисни бутона по-долу, за да научиш повече',
   },
   greenIn: {
     title: 'Зелена инициатива в опаковките за телевизори',
     subtitle1: 'Потърси информация за продукта',
     subtitle2: 'Екопакет за повторна употреба',
     desc: 'Потърси името на модела, за да получиш повече информация',
     descM: '* Снимай номера на модела на телевизора',
     guide: 'Име на модела',
     button: 'Направи снимка',
     button2: 'Отиди да сглобиш елементи',
     product_info: 'Информация за продукта',
   },
   search: {
     guide: 'Търсене..',
     noResult: 'Няма резултати',
     more: 'Научи повече ▼',
     search: 'Търсене',
     retake: 'Търси отново',
     result: 'Резултат',
   },
   photo: {
     guide1: 'Напиши името на модела телевизор в полето',
     guide2: '(напр. Q800A, UT7000, RU7100 и др.)',
   },
 },
 searchCountrySelect: 'Избери държава за търсене'
};
